<ng-http-loader
    [filteredUrlPatterns]="['/sequation-user-api/checkHeartbeat', '/sequation-user-api/refreshToken', '/sequation-job-api/ref-data/what/', '/sequation-job-api/ref-data/where/','/sequation-azure-appinsight-api/appInsight/addInteractionTime' ]">
</ng-http-loader>
<router-outlet></router-outlet>
